import { Report } from '@driftt/api-types'

// [impressions, sends, conversations, emailsCaptured, meetingsBooked, conversationsHeld]
export type ExperimentFlowMetrics = [
  number,
  number,
  number,
  number,
  number,
  number
]

export type ExperimentFlowReport = Report<
  [number, boolean],
  ExperimentFlowMetrics
>

export interface IUserActivitySummary {
  userId: string
  userName: string
  secondsActive: number
  secondsActivePerDay: number
}

export interface IConversationRepPerformance {
  user: number
  newConvos: number
  responseTime: number
  avgResponseTime: number
  convoLength: number
}

export interface IConversationRepPerformanceExport
  extends IConversationRepPerformance {
  liveChatRating: number
}

export interface IConversationURL {
  url: string
  value: number
}

export interface IConversationRep {
  user: number
  value: number
}

export interface IConversationTag {
  tag: string
  value: number
  percentage: string
  totalCount: number
}

export interface IConversationLiveChatRating {
  agentId: number
  liveChatRating: string
}

export interface IAgentConversationCount {
  agentId: number
  totalConvos: number
}

export interface ITicketsCreatedCount {
  agentId: number
  ticketsCreated: number
}

export interface IMissedChatsCount {
  TOTAL: number
  UNAVAILABLE: number
  CALENDAR_DROP: number
  AWAY_MESSAGE: number
  TICKET_CREATED: number
  REROUTE_WITHIN_TEAM: number
}

export enum SchedulingEventSummaryMetrics {
  CREATED_AT = 'createdAt',
  MEETING_START_AT = 'meetingStartAt',
  AGENT_ID = 'agentId',
  AGENT_NAME = 'agentName',
  END_USER_NAME = 'endUserName',
  STATUS = 'status',
  COMPANY = 'company',
  TITLE = 'title',
  MEETING_SOURCE = 'meetingSource',
}

export enum CallEventSummaryMetrics {
  AGENT_ID = 'agentId',
  AGENT_NAME = 'agentName',
  END_USER_ID = 'endUserId',
  END_USER_NAME = 'endUserName',
  END_USER_PHONE = 'endUserPhone',
  COMPANY_NAME = 'companyName',
  JOB_TITLE = 'jobTitle',
  CALL_START_DATE = 'createdAtDate',
  CALL_END_DATE = 'callEnd',
  DURATION = 'duration',
}

export type LineGraphResponse = [string, number][]

export interface IDateRange {
  startDate: string
  endDate: string
}

export enum PlaybookEventType {
  FORM_SUBMITTED = 'FORM_SUBMITTED',
  SENT = 'SENT',
  END_USER_ENGAGED = 'END_USER_ENGAGED',
  CONVERSATION_HELD = 'CONVERSATION_HELD',
  MEETING_BOOKED = 'MEETING_BOOKED',
  DISMISSED = 'DISMISSED',
}

export enum CountMetricType {
  MEETING = 'meeting',
  LEAD = 'lead',
}

export type ServiceDeflection = [number, number]
